﻿import { ImageSlider } from "./Search/Slider";

import React from "react";
import $ from "jquery";
if (typeof window !== "undefined") {
  window.$ = $;
  window.jQuery = $;
}

// ReSharper disable once Es6Feature
export default class SearchResultItem extends React.Component {
  constructor(props) {
    super(props);
    this.searchUrls = props.searchUrls;
    this.data = props.data;
    this.firmanavn = props.firmanavn;
    this.state = {
      morePartsStatus: "",
      showMoreInfo: false,
    };
  }

  toggleMoreInfo = () => {
    this.setState((prevState) => ({
      showMoreInfo: !prevState.showMoreInfo,
    }));
  };

  addItemToCart(e) {
    window.addItemToCart(e.target);
  }

  checkForMoreParts(id, producturl) {
    fetch("/api/parts/HasMore/?id=" + id)
      .then((res) => res.json())
      .then((result) => {
        if (result) window.location = producturl + "#moreparts";
        else this.setState({ morePartsStatus: "Fant ingen flere deler." });
      });
  }

  track_goToWebshopCheckout(e) {
    window.track_goToWebshopCheckout(e);
  }

  render() {
    return (
      <div id={"storage" + this.props.id} className="searchResultCard">
        <h3 className="searchResultTitle">
          <a
            href={"/" + this.props.firmanavn + this.data.URL}
            style={{ fontSize: "20px" }}
          >
            {this.data.Title}
          </a>
          <img
            className="brandListItemArrow"
            src="/images/CaretRightBlue.svg"
            alt="Arrow"
          />
        </h3>

        <div className="searchResultImage">
          <ImageSlider pictureUrls={this.data.PictureUrl} />
        </div>

        <div className="searchResultPris">
          <dt className="searchResultCardDT">Pris:</dt>
          {this.data.PartName != "Demonteringsobjekt" &&
            (!this.data.Price || this.data.Price === 0 ? (
              <dd className="searchResultCardDD">Ring for pris</dd>
            ) : (
              <dd className="searchResultCardDD">
                {this.data.PriceThousandSeperated} kr
              </dd>
            ))}
        </div>

        <div className="searchResultKjop">
         
        </div>


        <div className="searchResultActionButtons">
                <div className="searchResultForesporsel" style={{}}>
                    {this.props.firmanavn && this.props.firmanavn !== "nbf" ? (
                        <a
                            href={
                                "/" +
                                this.props.firmanavn +
                                "/Inquiry?storageid=" +
                                this.data.StorageId
                            }
                            data-storageid={this.props.id}
                            role="button"
                            data-onclick="track_addToInquiryList()"
                            style={{ color: "white" }}
                        >
                            Send forespørsel
                        </a>
                    ) : (
                        <a
                            onClick={this.addItemToCart}
                            data-storageid={this.props.id}
                            role="button"
                            style={{ color: "white" }}
                        >
                            Send forespørsel
                        </a>
                    )}
                </div>
                {this.data && this.data.PartIsAvailableForPurchase && (
                <div className="kjopButton">
                    
                        <form
                            action={"/" + this.props.firmanavn + "/checkout/step1"}
                            method="post"
                        >
                            <input
                                type="hidden"
                                name="storageid"
                                value={this.data.StorageId}
                            />
                            <input
                                type="submit"
                                value="Kjøp"
                                className="kjopButton"
                                onClick={this.track_goToWebshopCheckout}
                            />
                        </form>
                    
                    </div>
                )}
        </div>
        <div className="partDetailsSearchResultMoreInfoLarge">
          <ul className="searchResultCardDetailsWrapper">


                        
                        {this.data.PhysicalLocation &&
                          this.data.PhysicalLocation.toLowerCase().includes("bil") && (
                            <li className='doublebottom'>
                              <strong>
                                Merk at denne delen står på bilen og må demonteres før ekspedering &nbsp;
                              </strong>
                              <details style={{ display: "inline" }}>
                                <summary style={{ display: "inline" }}>
                                  (
                                  <span
                                    style={{
                                      cursor: "pointer",
                                            color: "#19549A",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    Hva betyr dette?
                                  </span>
                                  )
                                </summary>
                                <span>
                                  Dette betyr at delen må demonteres fra bilen før du kan kjøpe den. Litt avhengig av praksis og regler
                                  så vil enten forhandler eller du som kunde selv måtte demontere delen.
                                </span>
                              </details>
                            </li>
                          )
                        }
            {this.data.PartNumber && (
              <li>
                <span className="searchResultCardDT partno">Lagernummer: </span>
                <span className="searchResultCardDD partno">
                  {this.data.PartNumber +
                    (this.data.PhysicalLocation
                      ? " (" + this.data.PhysicalLocation + ")"
                      : "")}
                </span>
              </li>
            )}

            {this.data.Remark && (
              <li>
                <span className="searchResultCardDT">Anmerkning:</span>
                <span className="searchResultCardDD"> {this.data.Remark}</span>
              </li>
            )}

            {this.data.YearModel && (
              <li>
                <span className="searchResultCardDT">Årsmodell:</span>
                <span className="searchResultCardDD">{this.data.YearModel}</span>
              </li>
            )}

            {(this.data.EngineNotes || this.data.EngineNumber || this.data.EngineType) && (
              <li>
                <span className="searchResultCardDT">Motor: </span>
                <span className="searchResultCardDD">
                  {(this.data.EngineNotes ? this.data.EngineNotes + " " : "") +
                    (this.data.EngineNumber ? this.data.EngineNumber + " " : "") +
                    (this.data.EngineType ? this.data.EngineType : "")}{" "}
                </span>
              </li>
            )}

            {this.data.MileageThousandSeperated && (
              <li>
                <span className="searchResultCardDT">Km stand: </span>
                <span className="searchResultCardDD">
                  {this.data.MileageThousandSeperated}
                </span>
              </li>
            )}

            {this.data.OriginalCode && (
              <li>
                <span className="searchResultCardDT">Org.nr: </span>
                <span className="searchResultCardDD">
                  <a
                    title="Søk etter andre deler med dette originalnummer"
                    href={this.searchUrls?.otheroriginalcodesearchurl.replace(
                      "PLACEHOLDER",
                      this.data.OriginalCode
                    )}
                  >
                    {this.data.OriginalCode}
                  </a>
                </span>
              </li>
            )}

            {this.data.VisualOriginalNumber && (
              <li>
                <span className="searchResultCardDT">Visuelt Org.nr: </span>
                <span className="searchResultCardDD">
                  <a
                    title="Søk etter andre deler med dette visuelle originalnummer"
                    href={this.searchUrls?.othervisualoriginalcodesearchurl.replace(
                      "PLACEHOLDER",
                      this.data.VisualOriginalNumber
                    )}
                  >
                    {this.data.VisualOriginalNumber}
                  </a>
                </span>
              </li>
            )}

            {this.data.ArticleNumber && (
              <li>
                <span className="searchResultCardDT">Artikkel nr: </span>
                <span className="searchResultCardDD">
                  <a
                    title="Søk etter andre deler med dette artikkelnummer"
                    href={this.searchUrls?.otherarticlenosearchurl.replace(
                      "PLACEHOLDER",
                      this.data.ArticleNumber
                    )}
                  >
                    {this.data.ArticleNumber}
                  </a>
                </span>
              </li>
            )}

            {this.data.Gearcode && (
              <li>
                <span className="searchResultCardDT">Girkode: </span>
                <span className="searchResultCardDD">
                  <a
                    title="Søk etter andre deler med samme girkode"
                    href={this.searchUrls.othergearsearchurl.replace(
                      "PLACEHOLDER",
                      this.data.Gearcode
                    )}
                  >
                    {this.data.Gearcode}
                  </a>
                </span>
              </li>
            )}

            {this.data.EngineNumber && (
              <li>
                <span className="searchResultCardDT">Motorkode: </span>
                <span className="searchResultCardDD">
                  <a
                    title="Søk etter andre deler med denne motorkode"
                    href={this.searchUrls.otherenginesearchurl.replace(
                      "PLACEHOLDER",
                      this.data.EngineNumber
                    )}
                  >
                    {this.data.EngineNumber}
                  </a>
                </span>
              </li>
            )}
          </ul>

        <div id="sellerInfo">
          <a
            className="searchResultCardDD"
            href={"https://" + this.data.DealerLink}
            target="_blank"
            aria-label="Lenke til forhandler"
          >
            {" "}
            {this.data.DealerName}
          </a>
          <a
            className="searchResultCardDD"
            aria-label="Lenke til google maps for forhandler"
            href={
              "https://www.google.com/maps/search/?api=1&query=" +
              encodeURIComponent(this.data.DealerName) +
              "&query_place_id=" +
              this.data.MapId
            }
          >
            Vis på kart
          </a>
          <a className="searchResultCardDD" href={"tel:+47 " + this.data.Phone}>
            Tlf: {this.data.Phone}
          </a>
        </div>
            </div>
      </div>    
    );
  }
}
